// 我的企业模块
const getDefaultState = () => {
	return {
		// 是否绑定企业
		isHasCompany: false,
		// 是否是企业管理员（默认第一个绑定企业的为该企业的管理员）
		isCompanyAdmin: false,
		// 绑定的企业id（统一社会信用代码）
		companyId: ''
	}
}

const state = getDefaultState()

const mutations = {
	SET_COMPANY_BIND: (state, isBind) => {
		state.isHasCompany = isBind
	},
	SET_COMPANY_ADMIN: (state, adminTag) => {
		state.isCompanyAdmin = adminTag
	},
	SET_COMPANY_ID: (state, id) => {
		state.companyId = id
	}
}

const actions = {
	// 设置企业绑定
	setCompany({ commit }, companyId) {
		// 根据用户信息查询返回的companyId，如果有则代表绑定了企业，否则未绑定企业
		if (companyId) {
			commit('SET_COMPANY_BIND', true)
		} else {
			commit('SET_COMPANY_BIND', false)
		}
	},

	// 设置该用户是否为企业管理员标识
	setCompanyAdmin({ state, commit }, enterpriseAdmin) {
		if (state.isHasCompany && enterpriseAdmin) {
			commit('SET_COMPANY_ADMIN', true)
		} else {
			commit('SET_COMPANY_ADMIN', false)
		}
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
